import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = (selected: boolean) =>
  makeStyles((theme: Theme) => ({
    container: {
      height: theme.spacing(12),
      border: `1px solid ${theme.palette.secondary.light}`,
      borderRadius: theme.spacing(1),
      padding: theme.spacing(2),
      backgroundColor: selected ? theme.palette.primary.light : "#fff",
    },
    image: {
      width: "100%",
      height: "100%",
      maxHeight: theme.spacing(8),
      objectFit: "contain",
    },
    planName: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    button: {
      width: theme.spacing(15),
      minWidth: theme.spacing(15),
    },
  }));

export default useStyles;
